var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDatabase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M8.571 1v21M5.143 1h12.571c.607 0 1.188.246 1.617.683.428.438.669 1.031.669 1.65v14c0 .62-.24 1.213-.67 1.65a2.262 2.262 0 0 1-1.616.684H5.143a1.13 1.13 0 0 1-.808-.342A1.18 1.18 0 0 1 4 18.5V2.167c0-.31.12-.606.335-.825.214-.22.505-.342.808-.342ZM13 6h2m-2 5h2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatabase);
export default __webpack_public_path__ + "static/media/database.e9d1fff2aaedd713122bfcd11433da6b.svg";
export { ForwardRef as ReactComponent };